export default __webpack_public_path__ + "static/media/text-field-grouping.104d75ba.svg";